import * as React from 'react'

import { Button } from '~/client/src/shared/components/Button/Button'
import { AddIcon } from '~/client/src/shared/components/icons/AddIcon'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { useResourcePickerContext } from '../ResourcePickerContext'

interface IProps {
  onCancel: () => void
}

const PickerFooter: React.FC<IProps> = ({ onCancel }) => {
  const {
    selectedIds,
    hasSelection,
    onSelect,
    onCreateResource,
    startCreating,
    resetSelection,
    commitsOnPick,
    allowEmptySelection,
  } = useResourcePickerContext()

  const handleSave = React.useCallback(() => {
    onSelect(Array.from(selectedIds))
  }, [selectedIds, onSelect])

  const handleCancel = React.useCallback(() => {
    resetSelection()
    onCancel()
  }, [resetSelection, onCancel])

  if (commitsOnPick) {
    if (!onCreateResource) return null

    return (
      <div className="tw:flex tw:items-center tw:px-2.5 tw:pt-2.5 tw:pb-safe-3 tw:border-0 tw:border-t tw:border-solid tw:border-input-soft">
        <Button variant="outline" onClick={startCreating} size="lg">
          <AddIcon data-icon="inline-start" size="xs" />
          {Localization.translator.createNew}
        </Button>
      </div>
    )
  }

  return (
    <div className="tw:flex tw:justify-between tw:items-center tw:px-2.5 tw:pt-2.5 tw:pb-safe-3 tw:border-0 tw:border-t tw:border-solid tw:border-input-soft">
      {onCreateResource ? (
        <Button variant="outline" onClick={startCreating} size="lg">
          <AddIcon data-icon="inline-start" size="xs" />
          {Localization.translator.createNew}
        </Button>
      ) : (
        <div />
      )}
      <div className="tw:flex tw:items-center tw:gap-2">
        <Button variant="outline" onClick={handleCancel} size="lg">
          {Localization.translator.cancel}
        </Button>
        <Button
          variant="default"
          onClick={handleSave}
          disabled={!hasSelection && !allowEmptySelection}
          size="lg"
        >
          {Localization.translator.apply}
        </Button>
      </div>
    </div>
  )
}

export default PickerFooter
